import * as React from 'react';
import Box from '@mui/material/Box';
import Avatar from '@mui/material/Avatar';
import Menu from '@mui/material/Menu';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import ReusableModal from '../MUIComponent/Utlis/Modal/Modal';
import MenuItem from '@mui/material/MenuItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Tooltip from '@mui/material/Tooltip';
import PersonAdd from '@mui/icons-material/PersonAdd';
import Settings from '@mui/icons-material/Settings';
import Logout from '@mui/icons-material/Logout';
import { useTheme } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import { ROUTES } from '../../constants/routes';
import { useDispatch } from 'react-redux';
import { logout } from '../../features/auth/authSlice';
import { useAuth } from '../../hooks/useAuth';
import { styled, keyframes } from '@mui/system';
import PortraitIcon from '@mui/icons-material/Portrait';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import { handleLogout } from '../../services/logoutHandler';
import { useSnackbar } from '../MUIComponent/FeedbackComponent/SnackBar/SnackbarContext';
import configAPI from '../../api/config';
import { useParentKidAuth } from '../../hooks/parentKidUseAuth';
import { Roles } from '../../constants/params/constants';
import ChangePasswordWithOtp from './ChangePasswordWithOtp';
import ChangePasswordModal from './ChangePasswordModal';
import { useTranslation } from 'react-i18next';

// Smooth fade-in animation
const fadeIn = keyframes`
  from { opacity: 0; transform: translateY(-8px); }
  to { opacity: 1; transform: translateY(0); }
`;

// Subtle pulse animation
const subtlePulse = keyframes`
  0% { transform: scale(1); }
  50% { transform: scale(1.05); }
  100% { transform: scale(1); }
`;

const StyledAvatar = styled(Avatar)(({ theme }) => ({
  width: 30,
  height: 30,
  transition: 'all 0.2s ease',
  border: `1px solid ${theme.palette.mode === 'dark' ? theme.palette.grey[800] : '#fff'}`,
  // '&:hover': {
  //   animation: `${subtlePulse} 1.5s ease infinite`,
  //   boxShadow: theme.shadows[2],
  // },
}));

const CompactMenu = styled(Menu)(({ theme }) => ({
  '& .MuiPaper-root': {
    borderRadius: 8,
    minWidth: 200,
    boxShadow: '0px 8px 12px rgba(0, 0, 0, 0.1)',
    marginTop: '6px',
    '&::before': {
      content: '""',
      display: 'block',
      position: 'absolute',
      top: 0,
      right: 14,
      width: 10,
      height: 10,
      backgroundColor: theme.palette.background.paper,
      transform: 'translateY(-50%) rotate(45deg)',
      zIndex: 0,
      // boxShadow: '-1px -1px 1px rgba(0, 0, 0, 0.1)',
    },
    '& .MuiMenuItem-root': {
      padding: '8px 12px',
      margin: '0 4px',
      borderRadius: 6,
      fontSize: '0.875rem',
      transition: 'all 0.15s ease',
      '&:hover': {
        backgroundColor: theme.palette.action.hover,
        transform: 'translateX(2px)',
      },
      '& .MuiSvgIcon-root': {
        fontSize: '1rem',
      },
    },
  },
}));

const UserSummary = styled(Box)(({ theme }) => ({
  padding: '12px 16px',
  display: 'flex',
  alignItems: 'center',
  borderBottom: `1px solid ${theme.palette.divider}`,
}));

const UserText = styled(Box)({
  marginLeft: 12,
  lineHeight: 1.4,
});

const UserName = styled(Typography)(({ theme }) => ({
  fontWeight: 500,
  fontSize: '0.875rem',
}));

const UserRole = styled(Typography)(({ theme }) => ({
  fontSize: '0.75rem',
  color: theme.palette.text.secondary,
}));

export default function ProfileHeaderDropdown() {
  const { t } = useTranslation();
  const BASE_URL = configAPI.REACT_APP_API_BASE_URL;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation()
  const { user } = useAuth();
  const [openOtpModal, setOpenOtpModal] = React.useState(false);
  const { parentkidUser } = useParentKidAuth();
  const User = parentkidUser?.roleName === Roles[3].RoleName ? parentkidUser : user;
  const theme = useTheme();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const { showSnackbar } = useSnackbar();
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const getCacheBustedUrl = (url) => {
    if (!url) return null;
    return `${url}?t=${new Date().getTime()}`;
  };

  const avatarUrl = User?.ProfileUrl
    ? getCacheBustedUrl(`${BASE_URL}${User.ProfileUrl}`)
    : `${configAPI.REACT_APP_IMAGE_DYNAMIC_URL}/Documents/DefaultImage/user.jpg`;

  const handleClose = () => {
    setAnchorEl(null);
  };

 const handleClickLogout = () => {
  setAnchorEl(null);
  if (User?.schoolID) {

    localStorage.removeItem(`originalTheme_${User.schoolID}`);
  }

  handleLogout(dispatch, User, navigate, location, "manual", showSnackbar);
};


  const handleClearCache = async () => {
    handleClose();
    try {
      if ('caches' in window) {
        const cacheNames = await caches.keys();
        await Promise.all(cacheNames.map(cache => caches.delete(cache)));
      }
      if ('serviceWorker' in navigator) {
        const registrations = await navigator.serviceWorker.getRegistrations();
        for (let registration of registrations) {
          await registration.unregister();
        }
      }
      window.location.reload();
    } catch (error) {
      window.location.reload();
    }
  };

  return (
    <Box>
    <Box display="flex" sx={{gap:0.5}}>
   <UserText sx={{ml:0,display:{xs:'none',sm:'block'}}}>
  <UserName textTransform='capitalize' sx={{ color: theme.palette.custom.tableHeadingText }}>
    {User?.firstName?.trim() ||
      User?.fullName?.trim()?.split(" ")[0] ||
      t('header.user')}
  </UserName>

  <UserRole sx={{ color: "#8f01ff", textAlign: "end" ,marginTop:'-5px'}}>
    {User?.roleName || t('header.user')}
  </UserRole>
</UserText>
      <Tooltip title={t('common.profile')} arrow>
        <IconButton
          onClick={handleClick}
          size="small"
          sx={{
            p: 0,
            // '&:hover': {
            //   transform: 'scale(1.05)',
            // },
            // transition: 'transform 0.2s ease',
          }}
          aria-controls={open ? 'account-menu' : undefined}
          aria-haspopup="true"
          aria-expanded={open ? 'true' : undefined}
        >

          <StyledAvatar
            src={avatarUrl}
            alt={t('common.profile')}
          />

        </IconButton>
      </Tooltip>
</Box>
      <CompactMenu
        anchorEl={anchorEl}
        id="account-menu"
        open={open}
        onClose={handleClose}
        onClick={handleClose}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
        sx={{ zIndex: 23000 }}
      >
        <UserSummary>
          <StyledAvatar
            src={avatarUrl}
            alt={t('common.profile')}
          />
          <UserText>
            <UserName textTransform='capitalize'>{User?.fullName?.trim() ||
              [User?.firstName, User?.lastName].filter(Boolean).join(' ') ||
              t('header.user')}</UserName>
            <UserRole>{User?.roleName || t('header.user')}</UserRole>
          </UserText>
        </UserSummary>

       
         <MenuItem onClick={() => {
          handleClose();
          navigate(ROUTES.PROFILEPAGE);
        }}>
          <ListItemIcon >
           
            <i class="fa-sharp fa-regular fa-user"></i>
            
          </ListItemIcon>
          {t('header.myProfile')}
        </MenuItem>
         {/* <MenuItem onClick={() => {
          handleClose();
          navigate(ROUTES.AUDITLOG);
        }}>
          <ListItemIcon >
           
            <i class="fa-sharp fa-regular fa-timeline"></i>
            
          </ListItemIcon>
          Audit Log
        </MenuItem> */}
         <MenuItem onClick={() => {
          handleClose();
          navigate(ROUTES.TWOAUTHENTICATION);
        }}>
          <ListItemIcon >
           
            <i class="fa-sharp fa-regular fa-shield-keyhole"></i>
            
          </ListItemIcon>
          {t('header.twoStepAuthentication')}
        </MenuItem>
         <MenuItem onClick={() => {
        
            setOpenOtpModal(true);
            handleClose();
        }}>
          <ListItemIcon >
           
            <i class="fa-sharp fa-regular fa-key"></i>
            
          </ListItemIcon>
         {t('common.changePassword')}
        </MenuItem>
        {User?.roleName === 'Admin' && (
          <MenuItem onClick={() => {
            handleClose();
            navigate(ROUTES.CREATETICKET);
          }}>
            <ListItemIcon >
             
         <i class="fa-sharp fa-regular fa-headphones"></i>
            </ListItemIcon>
            {t('header.createTicket')}
          </MenuItem>
        )}

          {/* <MenuItem onClick={() => {
            handleClose();
            navigate(ROUTES.REMOTESUPPORT);
          }}>
            <ListItemIcon >
             
            <i class="fa-sharp fa-regular fa-person-chalkboard"></i>
            </ListItemIcon>
            Remote Support
          </MenuItem>  */}
        {/* <MenuItem onClick={handleClose}>
          <ListItemIcon>
            <Settings fontSize="small" />
          </ListItemIcon>
          Settings
        </MenuItem> */}


        {/* <MenuItem onClick={handleClose}>
          <ListItemIcon>
            <PersonAdd fontSize="small" />
          </ListItemIcon>
          Add account
        </MenuItem> */}

        <MenuItem onClick={handleClearCache}>
          <ListItemIcon>
            <i class="fa-sharp fa-regular fa-rotate-right"></i>
          </ListItemIcon>
          {t('header.clearCache')}
        </MenuItem>

        <MenuItem
          onClick={handleClickLogout}

        >
          <ListItemIcon>
            <i class="fa-sharp fa-regular fa-right-from-bracket"></i>
          </ListItemIcon>
          {t('common.logout')}
        </MenuItem>
      </CompactMenu>
      {/* <ReusableModal
  open={openOtpModal}
    onClose={() => setOpenOtpModal(false)}
   title="Change Password"
  fullWidth
>
  
   <ChangePasswordModal
  open={openOtpModal}
    onClose={() => setOpenOtpModal(false)}
/>

 
</ReusableModal> */}
<ChangePasswordModal
  open={openOtpModal}
  onClose={() => setOpenOtpModal(false)}
/>

    </Box>
  );
}